import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/Icon/Icon';
import './SDUI.scss';

/**
 * Alert - Displays info, warning, or success messages
 * 
 * @param {string} type - Alert type: 'info', 'warning', 'success'
 * @param {string} message - Alert message
 * @param {Object} action - Optional action button
 * @param {Function} onAction - Callback for action button
 */
export const Alert = ({ type = 'info', message, action, onAction }) => {
  const getIconName = () => {
    switch (type) {
      case 'warning':
        return 'Alert';
      case 'success':
        return 'Check';
      case 'info':
      default:
        return 'Info';
    }
  };

  const handleAction = () => {
    if (onAction && action) {
      onAction(action);
    }
  };

  return (
    <div className={`sdui-alert sdui-${type}`}>
      <Icon name={getIconName()} size='sm' />
      <div className={`${type}-content`}>
        <p>{message}</p>
        {action && (
          <button className={`${type}-action`} onClick={handleAction}>
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'success']).isRequired,
  message: PropTypes.string.isRequired,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string,
    target: PropTypes.string,
  }),
  onAction: PropTypes.func,
};

export default Alert;
